import { isAwaitingPayment } from 'entities/payment';
import { PaymentStatusState, PaymentType } from 'entities/payment/model';
import { STEPPER_ROUTES } from 'widgets/buy-package/lib/stepper';

export const resolveInitialStep = (payment: PaymentStatusState | null, isOwnedNft: boolean) => {
  if (isOwnedNft) {
    return STEPPER_ROUTES.OWNED_NFT;
  }

  if (!payment) return STEPPER_ROUTES.PAYMENT_INITIAL;

  if (isAwaitingPayment(payment)) {
    return payment.payload.paymentType === PaymentType.crypto
      ? STEPPER_ROUTES.PAYMENT_CRYPTO_AWAITING
      : STEPPER_ROUTES.PAYMENT_DEBIT_AWAITING;
  }

  return STEPPER_ROUTES.PAYMENT_INITIAL;
};
